import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VLayout,[_c(VFlex,[_c(VToolbar,{attrs:{"flat":""}},[_c('h3',{staticClass:"font-weight-light black--text"},[_vm._v(_vm._s(_vm.title))]),_c(VSpacer),_vm._l((_vm.getOptions),function(option){return _c(VBtn,{key:option.nome,staticClass:"mr-1",attrs:{"color":"blue","outlined":""},on:{"click":option.action}},[_vm._v(" "+_vm._s(option.nome)+" ")])})],2),_c(VContainer,{attrs:{"fluid":true}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }